export default "__VITE_ASSET__a606a951__"